// extracted by mini-css-extract-plugin
module.exports = {"image":"LoadingLogo_image__1v69D display-block centered width-60"};